import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Salon APIs
export const getSalons = () => api.get("/salons");
export const getAllSalons = () => api.get("/salons/all");
export const createSalon = (data) => api.post("/salons", data);
export const deleteSalon = (id) => api.delete(`/salons/${id}`);

// User Management APIs (Admin only)
export const getUsers = () => api.get("/users");
export const assignSalonsToUser = (userId, salonIds) => api.post("/users/assign-salons", { user_id: userId, salon_ids: salonIds });
export const bulkAssignSalons = (userIds, salonIds) => api.post("/users/bulk-assign-salons", { user_ids: userIds, salon_ids: salonIds });
export const updateUserRole = (userId, role) => api.post("/users/update-role", { user_id: userId, role });
export const deleteUser = (userId) => api.delete(`/users/${userId}`);

// Bulk Upload APIs (Admin only)
export const uploadSalesData = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/upload/sales", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};
export const downloadTemplate = () => api.get("/upload/template", { responseType: "blob" });

// Sales APIs
export const getSales = (params) => api.get("/sales", { params });
export const getSaleById = (id) => api.get(`/sales/${id}`);
export const createSale = (data) => api.post("/sales", data);
export const updateSale = (id, data) => api.put(`/sales/${id}`, data);
export const deleteSale = (id) => api.delete(`/sales/${id}`);
export const getPreviousClosing = (salonId, date) => api.get(`/sales/previous-closing/${salonId}`, { params: { date } });

// Dashboard API
export const getDashboard = (params) => api.get("/dashboard", { params });

// Export APIs
export const exportCSV = (params) => api.get("/export/csv", { params, responseType: "blob" });
export const exportPDFData = (params) => api.get("/export/pdf-data", { params });

export default api;
